<template>
	<div class="funnel-container">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'FunnelContainer',
}
</script>

<style lang="scss" scoped>
.funnel-container {
	min-height: 100vh;
	min-height: 100dvh;
}
</style>
